/**
 * The task slice — the richest of the four, and the one #154 prototyped and threw away.
 *
 * Not a face: `entries/` is one domain with one production face (ADR 0014:114-116). This index is
 * for the domain face and the sibling slices; a file outside `src/entries/` names neither.
 */

export type {
  ChecklistItem,
  StoredTaskPriority,
  StoredTaskStatus,
  TaskEntry,
  TaskFilterOptions,
  TaskMeta,
  TaskPriority,
  TaskStatus,
} from './meta'
export { isTaskEntry } from './guard'
export { PRIORITY_COLORS, PRIORITY_LABELS } from './priority'

export type { TaskDraft } from './write-spec'
export {
  useCompleteTask,
  useCreateTask,
  useDeleteTask,
  useDismissTask,
  useToggleChecklistItem,
  useUpdateTask,
} from './write-spec'

export type { TodayTasksResult } from './select-today'
export { selectTodayTasks, useTodayTasks } from './select-today'
export type { UpcomingTasksData } from './select-upcoming'
export { useUpcomingTasks } from './select-upcoming'
export type { TopicWithTaskCount } from './select-topic-counts'
export { useTaskTopicCounts } from './select-topic-counts'

export {
  isDueTodayCandidate,
  isProjectOverdue,
  isUpcomingCandidate,
} from './predicates'

export {
  TaskChecklist,
  TaskChecklistSummary,
  EditableTaskChecklist,
  createChecklistItems,
  toggleChecklistItem,
} from './checklist'

export { TaskRow } from './row'
export type { TaskEditFormProps } from './edit-form'
export { TaskEditForm } from './edit-form'
export { TodayTasks } from './today-view'
export { UpcomingTimeline } from './upcoming-view'
